var _style, _path, _path2, _path3, _g, _rect, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _defs, _rect3, _defs2, _rect4, _defs3, _rect5, _defs4, _rect6, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs5, _rect7, _defs6, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbralavQdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 198 64",
    style: {
      enableBackground: "new 0 0 198 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#1F2446;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_4_);}\n\t.st5{fill:url(#SVGID_5_);}\n\t.st6{fill:url(#SVGID_6_);}\n\t.st7{fill:url(#SVGID_7_);}\n\t.st8{fill:url(#SVGID_8_);}\n\t.st9{fill:none;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_9_);}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_11_);}\n\t.st13{clip-path:url(#SVGID_12_);fill:url(#SVGID_13_);}\n\t.st14{clip-path:url(#SVGID_14_);fill:url(#SVGID_15_);}\n\t.st15{clip-path:url(#SVGID_16_);fill:url(#SVGID_17_);}\n\t.st16{clip-path:url(#SVGID_18_);fill:url(#SVGID_19_);}\n\t.st17{fill:url(#SVGID_20_);}\n\t.st18{fill:url(#SVGID_21_);}\n\t.st19{fill:url(#SVGID_22_);}\n\t.st20{fill:url(#SVGID_23_);}\n\t.st21{fill:url(#SVGID_24_);}\n\t.st22{fill:url(#SVGID_25_);}\n\t.st23{fill:url(#SVGID_26_);}\n\t.st24{fill:url(#SVGID_27_);}\n\t.st25{fill:url(#SVGID_28_);}\n\t.st26{fill:url(#SVGID_29_);}\n\t.st27{fill:url(#SVGID_30_);}\n\t.st28{fill:url(#SVGID_31_);}\n\t.st29{fill:url(#SVGID_32_);}\n\t.st30{fill:url(#SVGID_33_);}\n\t.st31{clip-path:url(#SVGID_35_);fill:url(#SVGID_36_);}\n\t.st32{fill:none;stroke:url(#SVGID_39_);stroke-width:0.4494;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.0397,
    y1: 38.7082,
    x2: 166.0397,
    y2: 18.5907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.8,18.6h0.3c2.4,0,4.6,0.9,6.7,2.7v-2.6c0-0.1,0-0.1,0.1-0.1h3c0.1,0,0.1,0,0.1,0.1v19.9 c0,0.1,0,0.1-0.1,0.1h-3c-0.1,0-0.1,0-0.1-0.1V36c-2.1,1.8-4.2,2.7-6.5,2.7h-0.9c-2.5,0-4.8-1.1-7.1-3.4 c-1.6-2.1-2.4-4.2-2.4-6.5v-0.3c0-3.2,1.4-5.9,4.2-8.1C162,19.2,163.9,18.6,165.8,18.6z M159.2,28.5v0.3c0,2.4,1.2,4.3,3.5,5.8 c1.1,0.6,2.1,0.9,3,0.9h0.6c2.1,0,3.8-0.9,5.3-2.8c0.8-1.2,1.3-2.5,1.3-3.8v-0.5c0-2.5-1.3-4.5-4-6c-1-0.4-1.9-0.6-2.7-0.6h-0.2 c-1.7,0-3.3,0.6-4.7,1.9C159.9,25.2,159.2,26.8,159.2,28.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.7463,
    y1: 38.4281,
    x2: 150.7463,
    y2: 18.2765
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.7,34.9v3.5c-0.1,0-0.3,0-0.4,0h-0.2c-6.2,0.4-10-2.1-11.3-7.5c0-1.2,0-2-0.1-2.3 c0-1.1,0.1-2.3,0.1-3.7v-6.5c0-0.1,0-0.1,0.1-0.1h3c0.1,0,0.1,0,0.1,0.1V27l0.2,3.3c0.6,3.1,2.8,4.7,6.5,4.8 C155.4,35.2,156.1,35.1,156.7,34.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 187.3729,
    y1: 38.7082,
    x2: 187.3729,
    y2: 18.5907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M176.9,18.6h3c0.1,0.1,2.7,5.6,7.7,16.6c0.1-0.1,1.5-3.5,4.4-10.2c1.7-4.2,2.6-6.4,2.8-6.4h3.1l0.1,0.1 l-8.5,20.1h-3.4c-0.1-0.1-3.2-6.8-9.4-20.1L176.9,18.6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.5,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H67.5z M67,48.4L66,46l-1,2.3H67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.3,46.5C71,46.1,70.6,46,70.1,46c-0.4,0-1.2,0.2-1.2,0.8c0,0.5,0.5,0.6,1.2,0.7c0.7,0.1,1.5,0.3,1.5,1.1 c0,0.9-0.9,1.1-1.5,1.1c-0.6,0-1.3-0.2-1.6-0.8l0.3-0.1c0.2,0.5,0.8,0.7,1.3,0.7s1.2-0.1,1.2-0.8c0-0.6-0.6-0.7-1.3-0.8 c-0.7-0.1-1.4-0.3-1.4-1c0-0.8,0.8-1.1,1.4-1.1c0.5,0,1,0.1,1.4,0.6L71.3,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.3,46.5C75,46.1,74.6,46,74.1,46c-0.4,0-1.2,0.2-1.2,0.8c0,0.5,0.5,0.6,1.2,0.7c0.7,0.1,1.5,0.3,1.5,1.1 c0,0.9-0.9,1.1-1.5,1.1c-0.6,0-1.3-0.2-1.6-0.8l0.3-0.1c0.2,0.5,0.8,0.7,1.3,0.7c0.5,0,1.2-0.1,1.2-0.8c0-0.6-0.6-0.7-1.3-0.8 c-0.7-0.1-1.4-0.3-1.4-1c0-0.8,0.8-1.1,1.4-1.1c0.5,0,1,0.1,1.4,0.6L75.3,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.5,47.7c0,1-0.6,2-1.9,2c-1.3,0-1.9-1-1.9-2c0-1,0.6-2,1.9-2C79.8,45.7,80.5,46.6,80.5,47.7z M76.9,47.7 c0,0.9,0.5,1.7,1.6,1.7c1.1,0,1.6-0.8,1.6-1.7c0-0.9-0.5-1.7-1.6-1.7C77.5,46,76.9,46.8,76.9,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.9,49c-0.4,0.4-0.9,0.6-1.4,0.6c-1.3,0-2-0.9-2-1.9c0-1,0.7-2,2-2c0.5,0,1,0.2,1.4,0.6l-0.2,0.2 c-0.3-0.3-0.8-0.5-1.2-0.5c-1.1,0-1.7,0.8-1.7,1.7c0,0.9,0.6,1.7,1.7,1.7c0.4,0,0.9-0.2,1.2-0.5L84.9,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.1,49.6v-3.8h0.3v3.8H86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M90.8,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H90.8z M90.3,48.4l-1-2.3l-1,2.3H90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.4,50.1l0.1-0.5c-1.2-0.1-1.8-0.9-1.8-1.9c0-1,0.7-2,2-2c0.5,0,1,0.2,1.4,0.6l-0.2,0.2 c-0.3-0.3-0.8-0.5-1.2-0.5c-1.1,0-1.7,0.8-1.7,1.7c0,0.9,0.6,1.7,1.7,1.7c0.4,0,0.9-0.2,1.2-0.5L95,49c-0.4,0.4-0.9,0.6-1.3,0.6 l-0.1,0.3c0.4,0,0.6,0.3,0.5,0.5c-0.1,0.3-0.3,0.4-0.6,0.4c-0.2,0-0.5-0.1-0.6-0.3l0.2-0.2c0.1,0.2,0.2,0.2,0.4,0.2 c0.2,0,0.3-0.1,0.3-0.2C94,50.2,93.8,50,93.4,50.1L93.4,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M99.1,49.6l-0.4-0.9h-2.3L96,49.6h-0.3l1.7-3.8h0.3l1.7,3.8H99.1z M98.6,48.4l-1-2.3l-1,2.3H98.6z  M96.9,45.2c0-0.3,0.3-0.4,0.6-0.3l0.2,0.1c0.1,0.1,0.3,0,0.3-0.1l0.2,0.1c0,0.3-0.3,0.4-0.6,0.3l-0.2-0.1 c-0.1-0.1-0.3,0-0.3,0.1L96.9,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M103.9,47.7c0,1-0.6,2-1.9,2c-1.3,0-1.9-1-1.9-2c0-1,0.6-2,1.9-2S103.9,46.6,103.9,47.7z M100.4,47.7 c0,0.9,0.5,1.7,1.6,1.7c1.1,0,1.6-0.8,1.6-1.7c0-0.9-0.5-1.7-1.6-1.7S100.4,46.8,100.4,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110,46.8c0,0.4-0.2,0.7-0.6,0.8c0.5,0.1,0.8,0.5,0.8,1c0,0.8-0.7,1-1.4,1c-0.6,0-1,0-1.6,0v-3.8 c0.5,0,1,0,1.6,0C109.4,45.8,110,46.1,110,46.8z M107.5,47.5h1.3c0.5,0,0.9-0.1,0.9-0.7c0-0.6-0.5-0.8-1-0.8h-1.3V47.5z  M107.5,49.3h1.3c0.5,0,1.1-0.1,1.1-0.7c0-0.6-0.5-0.8-1.1-0.8c-0.5,0-0.8,0-1.3,0V49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.4,49.6h-0.4l-1.3-1.4h-1v1.4h-0.3v-3.8c0.6,0,1.1,0,1.7,0c0.8,0,1.2,0.6,1.3,1.2 c0,0.6-0.4,1.2-1.2,1.2L114.4,49.6z M111.7,47.9h1.3c0.7,0,1-0.4,1-0.9c0-0.4-0.3-0.9-0.9-0.9h-1.4V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.5,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H118.5z M118,48.4l-1-2.3l-1,2.3H118z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.3,46.5c-0.3-0.4-0.7-0.5-1.2-0.5c-0.4,0-1.2,0.2-1.2,0.8c0,0.5,0.5,0.6,1.2,0.7 c0.7,0.1,1.5,0.3,1.5,1.1c0,0.9-0.9,1.1-1.5,1.1c-0.6,0-1.3-0.2-1.6-0.8l0.3-0.1c0.2,0.5,0.8,0.7,1.3,0.7c0.5,0,1.2-0.1,1.2-0.8 c0-0.6-0.6-0.7-1.3-0.8c-0.7-0.1-1.4-0.3-1.4-1c0-0.8,0.8-1.1,1.4-1.1c0.5,0,1,0.1,1.4,0.6L122.3,46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.8,49.6v-3.8h0.3v3.8H123.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.7,45.8v3.5h2.1v0.3h-2.4v-3.8H125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.3,47.5h2.2v0.3h-2.2v1.5h2.4v0.3H129v-3.8h2.6V46h-2.3V47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132.9,49.6v-3.8h0.3v3.8H132.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.6,49.6h-0.4l-1.3-1.4h-1v1.4h-0.3v-3.8c0.6,0,1.1,0,1.7,0c0.8,0,1.2,0.6,1.3,1.2 c0,0.6-0.4,1.2-1.2,1.2L137.6,49.6z M134.8,47.9h1.3c0.7,0,1-0.4,1-0.9c0-0.4-0.3-0.9-0.9-0.9h-1.4V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.6,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H141.6z M141.1,48.4l-1-2.3l-1,2.3H141.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.1,47.6c0,1-0.6,1.9-1.9,1.9c-0.4,0-0.9,0-1.3,0v-3.8c0.4,0,0.9,0,1.3,0 C147.5,45.8,148.1,46.7,148.1,47.6z M145.2,46v3.2h1c1.1,0,1.7-0.8,1.6-1.7c0-0.8-0.5-1.6-1.6-1.6H145.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.6,47.5h2.2v0.3h-2.2v1.5h2.4v0.3h-2.7v-3.8h2.6V46h-2.3V47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155.6,45.8v3.5h2.1v0.3h-2.4v-3.8H155.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161.8,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H161.8z M161.3,48.4l-1-2.3l-1,2.3H161.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M165.7,45.8l-1.6,3.8h-0.3l-1.6-3.8h0.3l1.4,3.5l1.4-3.5H165.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M169.8,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H169.8z M169.3,48.4l-1-2.3l-1,2.3H169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M171.3,45.8l2.6,3.1v-3.1h0.3v3.8H174l-2.6-3.1v3.1h-0.3v-3.8H171.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M178.7,47.6c0,1-0.6,1.9-1.9,1.9c-0.4,0-0.9,0-1.3,0v-3.8c0.4,0,0.9,0,1.3,0 C178.1,45.8,178.7,46.7,178.7,47.6z M175.8,46v3.2h1c1.1,0,1.7-0.8,1.6-1.7c0-0.8-0.5-1.6-1.6-1.6H175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.2,47.5h2.2v0.3h-2.2v1.5h2.4v0.3h-2.7v-3.8h2.6V46h-2.3V47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M186.8,49.6h-0.4l-1.3-1.4h-1v1.4h-0.3v-3.8c0.6,0,1.1,0,1.7,0c0.8,0,1.2,0.6,1.3,1.2 c0,0.6-0.4,1.2-1.2,1.2L186.8,49.6z M184.1,47.9h1.3c0.7,0,1-0.4,1-0.9c0-0.4-0.3-0.9-0.9-0.9h-1.4V47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M187.9,49.6v-3.8h0.3v3.8H187.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M192.6,49.6l-0.4-0.9h-2.3l-0.4,0.9h-0.3l1.7-3.8h0.3l1.7,3.8H192.6z M192,48.4l-1-2.3l-1,2.3H192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M196.3,46.5c-0.3-0.4-0.7-0.5-1.2-0.5c-0.4,0-1.2,0.2-1.2,0.8c0,0.5,0.5,0.6,1.2,0.7 c0.7,0.1,1.5,0.3,1.5,1.1c0,0.9-0.9,1.1-1.5,1.1c-0.6,0-1.3-0.2-1.6-0.8l0.3-0.1c0.2,0.5,0.8,0.7,1.3,0.7c0.5,0,1.2-0.1,1.2-0.8 c0-0.6-0.6-0.7-1.3-0.8c-0.7-0.1-1.4-0.3-1.4-1c0-0.8,0.8-1.1,1.4-1.1c0.5,0,1,0.1,1.4,0.6L196.3,46.5z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.1875,
    y1: 41.7909,
    x2: 197.4802,
    y2: 41.7909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#95C122"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3242,
    style: {
      stopColor: "#FBEA1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6689,
    style: {
      stopColor: "#1B9DD9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984,
    style: {
      stopColor: "#2A3180"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.2,
    y: 41.5,
    className: "st4",
    width: 133.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8932,
    y1: 18.5907,
    x2: 131.8932,
    y2: 38.7082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48AE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#066938"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M141.8,18.6h-3c-0.1,0-0.1,0-0.1,0.1v2.6c-2.1-1.8-4.3-2.7-6.7-2.7h-0.3c-2,0-3.8,0.6-5.6,1.9 c-2.8,2.2-4.2,4.9-4.2,8.1v0.3c0,2.3,0.8,4.4,2.4,6.5c2.3,2.3,4.6,3.4,7.1,3.4h0.9c2.3,0,4.4-0.9,6.5-2.7v2.6 c0,0.1,0,0.1,0.1,0.1h3c0.1,0,0.1,0,0.1-0.1V18.7C142,18.6,141.9,18.6,141.8,18.6z M138.7,28.9c0,1.3-0.4,2.5-1.3,3.8 c-1.5,1.9-3.2,2.8-5.3,2.8h-0.6c-1,0-2-0.3-3-0.9c-2.3-1.5-3.5-3.4-3.5-5.8v-0.3c0-1.7,0.7-3.3,2-4.7c1.4-1.3,2.9-1.9,4.7-1.9 h0.2c0.8,0,1.7,0.2,2.7,0.6c2.7,1.5,4,3.5,4,6V28.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.654,
    y1: 18.5907,
    x2: 73.654,
    y2: 38.7082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48AE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#066938"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M83.6,18.6h-3c-0.1,0-0.1,0-0.1,0.1v2.6c-2.1-1.8-4.3-2.7-6.7-2.7h-0.3c-2,0-3.8,0.6-5.6,1.9 c-2.8,2.2-4.2,4.9-4.2,8.1v0.3c0,2.3,0.8,4.4,2.4,6.5c2.3,2.3,4.6,3.4,7.1,3.4H74c2.3,0,4.4-0.9,6.5-2.7v2.6c0,0.1,0,0.1,0.1,0.1 h3c0.1,0,0.1,0,0.1-0.1V18.7C83.7,18.6,83.7,18.6,83.6,18.6z M80.4,28.9c0,1.3-0.4,2.5-1.3,3.8c-1.5,1.9-3.2,2.8-5.3,2.8h-0.6 c-1,0-2-0.3-3-0.9c-2.3-1.5-3.5-3.4-3.5-5.8v-0.3c0-1.7,0.7-3.3,2-4.7c1.4-1.3,2.9-1.9,4.7-1.9h0.2c0.8,0,1.7,0.2,2.7,0.6 c2.7,1.5,4,3.5,4,6V28.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.0155,
    y1: 18.5567,
    x2: 115.0155,
    y2: 38.7082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48AE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#066938"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120.4,18.6c-6.2-0.4-10,2.1-11.3,7.5c0,1.2,0,2-0.1,2.3c0,1.1,0.1,2.3,0.1,3.7v6.5c0,0.1,0,0.1,0.1,0.1h3 c0.1,0,0.1,0,0.1-0.1V30l0.2-3.3c0.6-3.1,2.8-4.7,6.5-4.8c0.6,0,1.3,0.1,1.9,0.3v-3.5c-0.1,0-0.3,0-0.4,0H120.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.0324,
    y1: 12.9646,
    x2: 97.0324,
    y2: 38.7082
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48AE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#066938"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.1,18.6h-0.2c-2.4,0-4.6,0.9-6.6,2.6v-8.1c0-0.1,0-0.1-0.1-0.1h-3c-0.1,0-0.1,0-0.1,0.1v12.2 c0,1.3,0,2.6-0.1,3.6c0,0.4,0.1,1.5,0.1,3.2v6.5c0,0.1,0,0.1,0.1,0.1h3c0.1,0,0.1,0,0.1-0.1v-2.4c2.1,1.7,4.2,2.6,6.4,2.6h0.7 c1.7,0,3.5-0.5,5.2-1.6c3-2.2,4.5-4.9,4.5-8.1v-0.6c0-1.4-0.4-2.9-1.1-4.4C103.8,20.4,100.8,18.6,97.1,18.6z M103.9,28.8 c0,0.9-0.2,1.8-0.7,2.9c-1.5,2.5-3.5,3.8-6,3.8h-0.3c-1.4,0-2.8-0.5-4.1-1.5c-1.7-1.5-2.5-3.1-2.5-4.8v-1.1 c0-0.6,0.2-1.4,0.5-2.3c1.4-2.7,3.5-4,6.3-4c1.1,0,2.1,0.3,3.2,0.8c2.4,1.5,3.6,3.5,3.6,5.9V28.8z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 106.9,
    y: 22.4,
    className: "st9",
    width: 0.6,
    height: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 44.3528,
    x2: 3.4679,
    y2: 44.3528
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3.5,44.7c-1.5-0.8-1.2-0.4-1.4-2.1C1.3,44.1,1.7,43.8,0,44c1.5,0.8,1.2,0.4,1.4,2.1 C2.2,44.6,1.8,44.9,3.5,44.7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1672,
    y1: 34.1943,
    x2: 8.2929,
    y2: 34.1943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M3.4,38.3c1.9-3.4,1-2.9,4.9-3.2c-3.4-1.9-2.9-1-3.2-4.9c-1.9,3.4-1,2.9-4.9,3.2C3.6,35.2,3,34.4,3.4,38.3 "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.2875,
    y1: 40.7184,
    x2: 11.0248,
    y2: 40.7184
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M9.2,38.3c-1.1,2-0.6,1.7-2.9,1.9c2,1.1,1.7,0.6,1.9,2.9c1.1-2,0.6-1.7,2.9-1.9C9,40.1,9.4,40.6,9.2,38.3"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_57_",
    d: "M53.5,28.1c0.8,0,1.5,0.7,1.5,1.5c0,0.8-0.7,1.5-1.5,1.5c-0.8,0-1.5-0.7-1.5-1.5 C52,28.8,52.7,28.1,53.5,28.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.5323,
    y1: 31.1925,
    x2: 53.5323,
    y2: 27.7417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 28.1,
    className: "st13",
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_60_",
    d: "M49.4,23.6c1.2,0,2.1,0.9,2.1,2.1c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1 C47.3,24.5,48.3,23.6,49.4,23.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_60_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.4332,
    y1: 27.9093,
    x2: 49.4332,
    y2: 23.0848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47.3,
    y: 23.6,
    className: "st14",
    width: 4.2,
    height: 4.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_63_",
    d: "M49.3,32.1c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9 C48.4,32.5,48.8,32.1,49.3,32.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_63_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.3286,
    y1: 34.047,
    x2: 49.3286,
    y2: 31.8525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.4,
    y: 32.1,
    className: "st15",
    width: 1.9,
    height: 1.9
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_66_",
    d: "M54.9,20.4c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9 C53.9,20.8,54.4,20.4,54.9,20.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_66_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.8917,
    y1: 22.3344,
    x2: 54.8917,
    y2: 20.1433
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#086EB6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2C9FDA"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 20.4,
    className: "st16",
    width: 1.9,
    height: 1.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M24.2,32.2c0.5,0.1,1.2,0.1,2-0.3c1.2-0.5,2-0.7,2.6-0.8c0.4-0.3,0.7-0.4,1-0.5c0.4-0.1,2.1,0.4,3,0.6 c0.7,0.2,1.8,0.1,2.5,0.1l-0.1-0.4l3.4-0.6c-1.9-3.3-5.4-5.5-9.4-5.5c-3.9,0-7.3,2.1-9.2,5.2l4.4,1.5L24.2,32.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M36.3,38.1l-0.1-0.9c-0.2,0-0.6-0.1-0.9-0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0.4,0.5,0.7,0.8,0.8,1 c0.3,0.6-0.1,1.5-1,1.5c-0.4,0-1-0.5-1.6-0.9c0.1,0.1,0.1,0.1,0.2,0.2c0.7,0.7,1.6,1.3,1.1,2c-0.2,0.4-0.7,0.8-1.1,0.6 c-0.4-0.1-2.6-2-2.6-2s1.2,1,1.8,1.7c0.6,0.7-0.3,1.5-0.9,1.4c-0.3-0.1-1-0.5-1.5-0.9c0.8,0.6,1.2,1,0.6,1.6 c-0.4,0.4-0.8,0.4-2.1-0.4l-0.4,0.4c-0.3,0.2-0.7,0.2-0.9,0l-0.3-0.3c-0.2-0.3-0.2-0.7,0-0.9l0.1-0.1c0,0-0.1-0.1-0.1-0.1 l-0.4,0.4c-0.3,0.2-0.7,0.2-0.9,0l-0.3-0.3c-0.2-0.3-0.2-0.7,0-0.9l0.1-0.1c0,0-0.1-0.1-0.1-0.1l-0.4,0.4 c-0.3,0.2-0.7,0.2-0.9,0L24,40.3c-0.2-0.3-0.2-0.7,0-0.9l0.2-0.2c0,0-0.1-0.1-0.1-0.1l0,0c-0.3,0.2-0.7,0.2-0.9,0l-0.3-0.3 c-0.2-0.2-0.2-0.5-0.1-0.7c-0.2-0.2-0.5-0.4-0.6-0.5L22,38.4l-3.5-1.2c0.7,5.4,5.2,9.5,10.8,9.5c5.4,0,9.9-4,10.7-9.1 L36.3,38.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.2162,
    y1: 37.1059,
    x2: 35.8786,
    y2: 37.1059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48AE4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#066938"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M35.8,37.6c-0.1-0.2-0.4-0.6-0.8-1c-0.6-0.7-1.4-1.6-2.3-2.5c-1.1-1.2-2-2.7-3-2.8c0,0-0.3,0-0.8,0.1 c-0.6,0.1-1.4,0.3-2.6,0.8c-0.9,0.3-1.5,0.4-2,0.3l-2,5.5c0.2,0.1,0.4,0.3,0.6,0.5c0-0.1,0.1-0.2,0.2-0.2l1.3-1.1 c0.3-0.2,0.7-0.2,0.9,0l0.3,0.3c0.2,0.3,0.2,0.7,0,0.9l-1.2,1.1c0,0,0.1,0.1,0.1,0.1l1.1-1c0.3-0.2,0.7-0.2,0.9,0l0.3,0.3 c0.2,0.3,0.2,0.7,0,0.9l-0.9,0.8c0,0,0.1,0.1,0.1,0.1l1.1-1c0.3-0.2,0.7-0.2,0.9,0l0.3,0.3c0.2,0.3,0.2,0.7,0,0.9l-0.8,0.8 c0,0,0.1,0.1,0.1,0.1l1.2-1.1c0.3-0.2,0.7-0.2,0.9,0l0.3,0.3c0.2,0.3,0.2,0.7,0,0.9l-0.8,0.8c1.3,0.8,1.7,0.9,2.1,0.4 c0.6-0.6,0.2-1-0.6-1.6c0.5,0.4,1.2,0.8,1.5,0.9c0.6,0.1,1.5-0.7,0.9-1.4C32,40,30.8,39,30.8,39s2.2,1.9,2.6,2 c0.4,0.1,0.9-0.2,1.1-0.6c0.5-0.8-0.4-1.3-1.1-2c-0.1-0.1-0.1-0.1-0.2-0.2c0.5,0.4,1.2,0.9,1.6,0.9 C35.7,39.1,36.1,38.2,35.8,37.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.7249,
    y1: 33.9992,
    x2: 36.18,
    y2: 33.9992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.3,31.5c-0.7,0-1.8,0-2.5-0.1c-1-0.2-2.6-0.7-3-0.6c-0.3,0.1-0.5,0.1-0.8,0.3c0,0,0,0,0,0 c-0.1,0.1-0.3,0.3-0.5,0.5c-0.8,0.8-1.4,1.6-1.6,1.8c-0.2,0.2,0.5,0.7,1.4,0.6c0.9-0.1,1.6-0.8,2.1-1.3 c0.4-0.4,1.3,0.3,2.1,1c0.1,0.1,0.2,0.2,0.3,0.3c0.9,1,1.8,1.9,2.3,2.5c0.1,0.1,0.2,0.2,0.3,0.3c0.4,0.4,0.7,0.4,0.9,0.4 L35.3,31.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9621,
    y1: 42.0875,
    x2: 42.0035,
    y2: 42.0875,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M25.4,37.2l-0.3-0.3c-0.2-0.3-0.6-0.3-0.9,0L23,38c-0.1,0.1-0.1,0.1-0.2,0.2c0.4,0.3,0.8,0.6,1.3,1 l1.2-1.1C25.6,37.8,25.7,37.4,25.4,37.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9621,
    y1: 43.3255,
    x2: 42.0035,
    y2: 43.3255,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M26.5,38.6l-0.3-0.3c-0.2-0.3-0.6-0.3-0.9,0l-1.1,1c0.4,0.3,0.9,0.7,1.4,1l0.9-0.8 C26.7,39.3,26.7,38.9,26.5,38.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9621,
    y1: 44.371,
    x2: 42.0035,
    y2: 44.371,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M28,39.7l-0.3-0.3c-0.2-0.3-0.7-0.3-0.9,0l-1.1,1c0.5,0.3,1,0.7,1.4,1l0.8-0.8 C28.3,40.4,28.3,40,28,39.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9621,
    y1: 45.3364,
    x2: 42.0035,
    y2: 45.3364,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M29.6,40.7l-0.3-0.3c-0.2-0.3-0.7-0.3-0.9,0l-1.2,1.1c0.2,0.1,0.4,0.2,0.5,0.3c0.4,0.2,0.7,0.4,0.9,0.6 l0.8-0.8C29.8,41.4,29.8,41,29.6,40.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 27.9621,
    y1: 38.9672,
    x2: 42.0035,
    y2: 38.9672,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M23.2,31.8c0,0-1,2.5-1.2,3.7c-0.2,1.2-0.1,1.9-0.1,1.9s0.1,0.1,0.3,0.2l2-5.5 C23.5,32.1,23.2,31.8,23.2,31.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.3968,
    y1: 34.2804,
    x2: 24.4055,
    y2: 34.2804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B4B4"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M24.2,32.2l0.2-0.6L20,30.2c-1,1.7-1.6,3.6-1.6,5.7c0,0.4,0,0.9,0.1,1.3l3.5,1.2l0.2-0.7c0,0,0,0,0,0 L24.2,32.2C24.2,32.2,24.2,32.2,24.2,32.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 32.6365,
    y1: 38.2173,
    x2: 42.5918,
    y2: 38.2173,
    gradientTransform: "matrix(0.9997 2.550000e-02 -2.550000e-02 0.9997 -5.0438 -4.9288)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M36.4,37.2c0,0,0.5-3.7-0.5-5.8c0,0-0.2,0-0.6,0l0.8,5.8C36.3,37.3,36.4,37.2,36.4,37.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.2849,
    y1: 34.2958,
    x2: 40.1079,
    y2: 34.2958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B4B4B4"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M38.7,30.5l-3.4,0.6l0.1,0.4c0,0,0,0,0,0l0.8,5.8c0,0,0,0,0,0l0.1,0.9l3.7-0.5c0.1-0.6,0.1-1.1,0.1-1.7 C40.1,33.9,39.6,32.1,38.7,30.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.7701,
    y1: 38.0216,
    x2: 25.5805,
    y2: 38.0216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M24.1,39.2C24.1,39.2,24.1,39.2,24.1,39.2l1.2-1.1c0.3-0.2,0.3-0.7,0-0.9l-0.3-0.3 c-0.2-0.3-0.6-0.3-0.9,0L23,38c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0,0,0c-0.1,0.2-0.1,0.5,0.1,0.7l0.3,0.3 C23.4,39.4,23.8,39.5,24.1,39.2L24.1,39.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.8586,
    y1: 39.4694,
    x2: 26.6691,
    y2: 39.4694
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M25.6,40.3l0.9-0.8c0.3-0.2,0.3-0.6,0-0.9l-0.3-0.3c-0.2-0.3-0.6-0.3-0.9,0l-1.1,1c0,0,0,0,0,0 l-0.2,0.2c-0.3,0.2-0.3,0.6,0,0.9l0.3,0.3c0.2,0.3,0.6,0.3,0.9,0L25.6,40.3C25.6,40.3,25.6,40.3,25.6,40.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.3888,
    y1: 40.5576,
    x2: 28.1998,
    y2: 40.5576
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M27.1,41.4l0.8-0.8c0.3-0.2,0.3-0.6,0-0.9l-0.3-0.3c-0.2-0.3-0.7-0.3-0.9,0l-1.1,1c0,0,0,0,0,0 l-0.1,0.1c-0.3,0.2-0.3,0.6,0,0.9l0.3,0.3c0.2,0.3,0.6,0.3,0.9,0L27.1,41.4C27.1,41.4,27.1,41.4,27.1,41.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.9621,
    y1: 41.5677,
    x2: 29.7733,
    y2: 41.5677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9B03D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FCE21F"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M29.6,40.7l-0.3-0.3c-0.2-0.3-0.7-0.3-0.9,0l-1.2,1.1c0,0,0,0,0,0l-0.1,0.1c-0.3,0.2-0.3,0.6,0,0.9 l0.3,0.3c0.2,0.3,0.6,0.3,0.9,0l0.4-0.4c0,0,0,0,0,0l0.8-0.8C29.8,41.4,29.8,41,29.6,40.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_83_",
    d: "M39.9,12.9c0,0.3,0.3,0.6,0.6,0.6h1.1c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.1 C40.2,12.2,39.9,12.5,39.9,12.9 M36.7,12.9c0,0.3,0.3,0.6,0.6,0.6h1.1c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.1 C37,12.2,36.7,12.5,36.7,12.9z M34.2,12.2c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h1.1c0.3,0,0.6-0.3,0.6-0.6 c0-0.3-0.3-0.6-0.6-0.6H34.2z M16.5,13.5H24c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-7.5c-0.3,0-0.6,0.3-0.6,0.6 C15.8,13.2,16.1,13.5,16.5,13.5z M12.3,15.8V13c0-1.7,1.4-3.1,3.1-3.1h27.4c1.7,0,3.1,1.4,3.1,3.1v2.7H12.3z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.2675,
    y1: 12.8505,
    x2: 45.9166,
    y2: 12.8505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_34_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_35_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_83_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.092,
    y1: 19.0878,
    x2: 29.092,
    y2: 9.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3,
    y: 9.9,
    className: "st31",
    width: 33.6,
    height: 5.8
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_87_",
    d: "M29.1,47.9c-6.6,0-12-5.4-12-12.1c0-6.7,5.4-12.1,12-12.1c6.6,0,12,5.4,12,12.1 C41.1,42.5,35.7,47.9,29.1,47.9 M45.8,50c0,2.2-1.4,4.1-3.1,4.1H15.5c-1.7,0-3.1-1.8-3.1-4.1V17h33.5V50z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.092,
    y1: 54.0734,
    x2: 29.092,
    y2: 17.0182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_37_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_87_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.1721,
    y1: 35.846,
    x2: 40.3325,
    y2: 35.846
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2175BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1F2446"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st32",
    cx: 29.3,
    cy: 35.8,
    r: 10.9
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbralavQdd);
export default __webpack_public_path__ + "static/media/abralav-qdd.5d1584c6b9d2a80ab13cd436616a79fc.svg";
export { ForwardRef as ReactComponent };